import * as constants from '../constants/CONSTANT';

const AiDictionaryApi = {
  async list() {
    const token = localStorage.getItem('token');
    const response = await fetch(constants.API_BASE_URL + '/api/objectconfig/ai-dictionary', {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    return response.json();
  },

  async create(payload) {
    const token = localStorage.getItem('token');
    const response = await fetch(constants.API_BASE_URL + '/api/objectconfig/ai-dictionary', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });
    return response.json();
  },

  async update(term, payload) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/ai-dictionary/${encodeURIComponent(term)}`,
      {
        method: 'PUT',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        body: JSON.stringify(payload),
      }
    );
    return response.json();
  },

  async remove(term) {
    const token = localStorage.getItem('token');
    const response = await fetch(
      constants.API_BASE_URL + `/api/objectconfig/ai-dictionary/${encodeURIComponent(term)}`,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      }
    );
    return response.json();
  },
};

export default AiDictionaryApi;
